export const ALLOWED_FIELDS = Object.freeze([
  'name',
  'shortname',
  'country',
  'commentary',
  'names',
  'surnames',
  'secondName',
  'number',
  'dateOfIssue',
  'endDate',
  'gender',
  'birthDate',
  'placeOfBirth',
  'issuedBy',
  'issuerCode',
  'other',
  'idStatus',
  'comments',
  'storageLocation',
  'otherStorageLocation',
  'storageComments',
  'legalizedCopy',
  'address',
] as const);
